import { render, staticRenderFns } from "./DashContainer.vue?vue&type=template&id=8536efd4&scoped=true&"
import script from "./DashContainer.vue?vue&type=script&lang=ts&"
export * from "./DashContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DashContainer.vue?vue&type=style&index=0&id=8536efd4&scoped=true&lang=css&"
import style1 from "./DashContainer.vue?vue&type=style&index=1&id=8536efd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8536efd4",
  null
  
)

export default component.exports